import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CompanyInn as SchemaCompanyInn } from '../schemas/CompanyInn';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Company
 */
export const GetCompanyInnContentType = '' as const;
export type GetCompanyInnRequest = void;
export type GetCompanyInnResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful get company INN
     */
    '200': {
        'application/json': SchemaCompanyInn;
    };
};
export type GetCompanyInnResponseSuccess = GetCompanyInnResponses['200']['application/json'];
export type GetCompanyInnSearchParams = undefined;
export type GetCompanyInnPathParameters = undefined;
export const GetCompanyInnUrl = '/company/inn' as const;
export const GetCompanyInnMethod = 'GET' as const;
export const getGetCompanyInnUrl = (_params?: GetCompanyInnPathParameters) => GetCompanyInnUrl;
